import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useFormContext } from '../../providers';
import { EmergencyContact, ImageSection, MailingAddressSection, ProfileSection, SocialMediaForm, SubmitAndDraftSection } from './components';
import { FaCheck } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { useAuthHandler } from '../../hooks';
import { errorPopup } from '../../helpers';
import Swal from 'sweetalert2';

export const ProfileForm = () => {
    const { onProfileSubmit, watch, isSubmitting, trigger, errors } = useFormContext();
    // const { profileCompleteness } = useProfile();
    const { getCurrentUser } = useAuthHandler();
    const [loading, setLoading] = useState(false);
    const formRef = useRef(null);

    const submitForm = useCallback(async (event) => {

        event.preventDefault();
        // Trigger validation for all fields
        const isValid = await trigger();

        console.log(isValid)
        // If there are errors, don't submit
        if (!isValid) {
            return;
        }

        setLoading(true); // show loading spinner
        onProfileSubmit(watch(), event).then(() => {
            getCurrentUser();
            setLoading(false); // hide loading spinner
        }).catch(() => {
            setLoading(false); // hide loading spinner
            errorPopup('', 'Failed to submit profile');
        });

    }, [getCurrentUser, onProfileSubmit, trigger, watch]);


    useEffect(() => {
        console.log(errors)
        if (!errors || Object.keys(errors).length === 0) return;

        // Function to recursively find the first error message
        const findFirstErrorMessage = (errorObj) => {
            if (errorObj.message) {
                return errorObj.message;
            }

            if (Array.isArray(errorObj)) {
                for (const item of errorObj) {
                    if (item && typeof item === 'object') {
                        const message = findFirstErrorMessage(item);
                        if (message) return message;
                    }
                }
            } else if (typeof errorObj === 'object') {
                for (const key in errorObj) {
                    const message = findFirstErrorMessage(errorObj[key]);
                    if (message) return message;
                }
            }

            return null;
        };

        const firstErrorMessage = findFirstErrorMessage(errors);

        if (firstErrorMessage) {
            Swal.fire({
                icon: 'error',
                text: firstErrorMessage,
                confirmButtonColor: '#d33',
            });
        } else {
            Swal.fire({
                icon: 'error',
                text: 'Please correct the errors in the form',
                confirmButtonColor: '#d33',
            });
        }
    }, [errors]);

    return (
        <div className="col-md-12 !px-8 profile-form-container">
            <div className="flex flex-col gap-5 dashboard-title flex-start">
                <div style={{ textAlign: "center" }} className="ps-6 dashboard-title">
                    <h3 style={{ color: "#3b4249" }}>Profile</h3>
                </div>
                <h4 style={{ textDecoration: "underline" }}>
                    Note : Please complete all required fields. After that admin will verify your account before you can host or book.
                </h4>
            </div>
            <div className="row">
                {/* First Column: Full width on small devices */}
                <div className="col-md-8 col-12">
                    <form ref={formRef} onSubmit={submitForm} className="p-6 space-y-4">
                        <ImageSection />
                        <ProfileSection />
                        <MailingAddressSection />
                        <EmergencyContact />
                        <SocialMediaForm />
                        <SubmitAndDraftSection isSubmitting={isSubmitting || loading} />
                    </form>
                </div>

                {/* Second Column: Hidden on small devices */}
                <div className="pt-6 col-md-4 d-none d-md-block">
                    <div className="profile-edit-container fl-wrap block_box">
                        <div style={{ marginBottom: "0px" }} className="dashboard-title fl-wrap">
                            <h3
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    color: "#af2322",
                                }}
                            >
                                Profile Status:
                            </h3>

                            {JSON.parse(localStorage.getItem('data'))?.profile_completeness === 100 &&
                                <h1
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        color: "#8ec639",
                                    }}
                                >
                                    {JSON.parse(localStorage.getItem('data'))?.profile_completeness + '%' || 100} Complete
                                </h1>
                            }
                            {JSON.parse(localStorage.getItem('data'))?.profile_completeness > 91 && JSON.parse(localStorage.getItem('data'))?.profile_completeness < 97 &&
                                <h1
                                    className='!text-lg gap-3'
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        color: "#8ec639",
                                    }}
                                >
                                    Your account is currently <h1 className='text-[#8Dc539] text-3xl capitalize contents'

                                        style={{
                                            textDecoration: 'underline'
                                        }}
                                    >under review</h1>. <br />Our verification process typically takes up to 60 minutes.<br />

                                    Once your submitted profile details are verified, your profile will be marked as 100% complete.<br />

                                    You'll receive an email notification as soon as the verification process is finished. Thank you for your patience.
                                </h1>
                            }

                            {JSON.parse(localStorage.getItem('data'))?.profile_completeness < 91 &&
                                <h1
                                    className='!text-lg'
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        color: "#8ec639",
                                    }}
                                >
                                    Your account has been started. Please fill in the details so we can verify your profile.
                                </h1>
                            }


                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    paddingTop: "20px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                    }}
                                >
                                    <h4>Profile Picture</h4>
                                    <p style={{ paddingTop: watch('image') ? "10px" : "0px" }}>
                                        {watch('image') ? (
                                            <FaCheck style={{ color: "#8ec639", fontSize: "17px" }} />
                                        ) : (
                                            <MdClose
                                                style={{
                                                    color: "#8ec639",
                                                    fontSize: "20px",
                                                    paddingTop: "3px",
                                                }}
                                            />
                                        )}
                                    </p>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                    }}
                                >
                                    <h4>Email Address</h4>
                                    <p
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "5px",
                                            color: "#8ec639",
                                        }}
                                    >
                                        {parseInt(watch('status')) === 1 ? (
                                            <FaCheck style={{ color: "#8ec639", fontSize: "17px" }} />
                                        ) : (
                                            <MdClose
                                                style={{
                                                    color: "#8ec639",
                                                    fontSize: "20px",
                                                    paddingTop: "3px",
                                                }}
                                            />
                                        )}
                                        VERIFIED
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};
